import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CheckboxListModel } from '../../../../shared/checkbox-list';
import { AppTextService } from '../../../../shared/app-text';
import { FiDialogsContentBase } from '../../../../shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-ad-import-choose-groups-dialog',
    templateUrl: './ad-import-choose-groups-dialog.component.html',
    styleUrls: ['./ad-import-choose-groups-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class AdImportChooseGroupsDialogComponent
    extends FiDialogsContentBase<ILightWeightADGroup[], ILightWeightADGroup[]>
    implements OnInit
{
    adGroupsListData = new CheckboxListModel();
    private appTextService: AppTextService;

    ngOnInit(): void {
        this.appTextService = this.injector.get(AppTextService);
        this.adGroupsListData.DataNameField = 'Name';
        this.adGroupsListData.DataIdField = 'Guid';
        this.adGroupsListData.HeaderName = this.appTextService.get('ad_integration.org_units');
        this.adGroupsListData.ShowHeader = true;
        this.adGroupsListData.DataSet = this.data.map((item) => Object.assign(item, { Checked: true }));
    }

    getResult(): ILightWeightADGroup[] {
        return this.adGroupsListData.DataSet.filter((item) => item.Checked);
    }

    isYesButtonDisabled() {
        return !this.adGroupsListData.DataSet.find((item) => item.Checked);
    }
}
